
// @ts-ignore
export default function imageLoader({src}) {
    return `${src}`; // REPLACE WITH YOUR IMAGE DIRECTORY
}

